import React from 'react';
import { Helmet } from 'react-helmet';

const HelmetDom = () => {
    return (
        <Helmet>
            <title>金智塔科技-可信数据空间，数据要素合规流通平台，隐私计算平台，AI智能体，大模型，数据要素合规流通与智能应用，数据可用不可见</title>
            <meta property="og:title" content="可信数据空间，数据要素合规流通平台，隐私计算平台，AI智能体，大模型，数据要素合规流通与智能应用，数据可用不可见" />
            <meta property="og:description" content="可信数据空间，数据要素合规流通平台，隐私计算平台，AI智能体，大模型，数据要素合规流通与智能应用，数据可用不可见" />
            <meta
                name="description"
                content="金智塔科技是由浙江大学人工智能研究所和浙江大学金融科技研究院联合发起的可信人工智能基础设施领军企业，构建涵盖“数据可信-模型可信-应用可信”的全栈人工智能技术体系，自主研发隐私计算平台、数据合规流通平台、可信数据空间、AI智能体平台等核心产品，为金融机构、大型企业和政府部门等提供数据合规流通与智能应用的一站式解决方案。"
            />
            <link rel="shortcut icon" href={require('@@/assets/img/favicon.png')} />
        </Helmet>
    );
};

export default HelmetDom;
